import jwtDecode from 'jwt-decode';
import AccessToken from './AccessToken';

export const decodeAccessToken = (jwt: string) => {
  return jwtDecode<AccessToken>(jwt);
};

export const isExpired = (jwt: string) => {
  const token = decodeAccessToken(jwt);
  const expDate = new Date(token.exp * 1000);
  const nowDate = new Date(Date.now());
  return expDate <= nowDate;
};
